module.exports = __webpack_public_path__ + "static/img/6.1351ff2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/sp/6.png
// module id = Fs/B
// module chunks = 0